var React = require('react');
var Shopify = require('./shopify');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var ReactDOM = require('react-dom');
var Reflux = require('reflux');
var ScreenWid = require('./stores/screen-wid-store');
var CatMenus = require('./cat-menu');

module.exports = React.createClass({

  mixins: [ Reflux.ListenerMixin ],

  curWidth: "",

  getInitialState: function() {
    var extra = this.props.extra;

    if (this.props.withGenderBtns) {
      extra = <div ref="btnMobile">
                    <div className="mobile-header-btn">
                      <Link to={CMS.home.btnLink} className="btn btn-white">{CMS.home.btnText}</Link>
                    </div>
                    <div className="mobile-header-btn">
                      <Link to={CMS.home.btn2Link} className="btn btn-white">{CMS.home.btn2Text}</Link>
                    </div>
              </div>;
    }
    return { title: this.props.title ? this.props.title : "",
             desc: this.props.desc ? this.props.desc : "",
             btnText: this.props.btnText ? this.props.btnText : "",
             btnLink: this.props.btnLink ? this.props.btnLink : "",
             extra: extra };
  },

  componentDidMount: function() {
    this.onScreenWid(null, ScreenWid.width);
    this.listenTo(ScreenWid, this.onScreenWid);

    var rootDiv = jQuery(this.refs.root);
    if ("SM" == ScreenWid.width) {
      rootDiv.css("background", 'url("' + this.props.imageM + '") center bottom no-repeat');
    } else {
      rootDiv.css("background", 'url("' + this.props.image + '") center bottom no-repeat');
    }
  },

  onScreenWid: function(event, wid) {
    this.curWidth = wid;
    if ("SM" == wid) {
      if (this.props.hideNormalOnSmall) {
        jQuery(ReactDOM.findDOMNode(this.refs.normal)).addClass('hide');
      }
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.normal)).removeClass('hide');
    }
    if ("LG" != wid && !this.props.withGenderBtns) {
      jQuery(ReactDOM.findDOMNode(this.refs.subHeading)).addClass('cat-menu-heading');
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.subHeading)).removeClass('cat-menu-heading');
    }
  },

  setContent: function(title, desc, btnText, btnLink, img) {
    var rootDiv = jQuery(this.refs.root);

    rootDiv.css("background", 'url("' + img + '") center bottom no-repeat');  
    this.setState({ title: title,
                    desc: desc,
                    btnText: btnText,
                    btnLink: btnLink });
  },

  setExtra: function(extra) {
    this.setState({ extra: <h1>{extra}</h1> });
  },

  setImage: function(img) {
    var rootDiv = jQuery(this.refs.root);

    rootDiv.css("background", 'url("' + img + '") center bottom no-repeat');
  },

  toggleMenu: function() {
    if ("LG" == this.curWidth) return;

    this.refs.catMenus.toggleMenus();
  },

  render: function() {
    var secondBtn = null;

    if (this.props.btn2Text) {
      secondBtn = <Link className="btn btn-white hidden-xs" to={this.props.btn2Link}>
                      {this.props.btn2Text}
                  </Link>
    }
    return <header ref="root" 
                   className={"full-width" + (this.props.className ? " " + this.props.className : "")}>
        <div className="container">
            <div className="row" ref="normal">
                <div className="col-sm-6">
                    <h1>{this.state.title}</h1>
                    <p>{this.state.desc}</p>
                    <div>
                        <Link className="btn btn-white hidden-xs" to={this.state.btnLink}>
                            {this.state.btnText}
                        </Link>
                    </div>
                    <div>{secondBtn}</div>
                </div>
            </div>
            <div ref="extra" className="visible-xs-block">
                {this.state.extra}
            </div>
            
            <h2 ref="subHeading" onClick={this.toggleMenu}>{this.props.subHeading}</h2>
            {this.props.menus ? <CatMenus ref="catMenus" gender={this.props.pageName}
                                          from="hf" menus={this.props.menus}/> : null}
        </div>
    </header>
  }
});